import { css } from "@linaria/core"
import { styled } from "@linaria/react"

import { Button } from "@/components/Button/Button.tsx"
import { EllipsisContainer } from "@/components/Ellipsis/Ellipsis.ts"

const Container = styled.div`
  position: relative;

  padding: 8px 8px 8px 40px;

  background-color: var(--island-background-color);
`

const CloseButton = styled(Button)`
  position: absolute;
  right: 8px;
  top: 8px;
`

const Collapse = styled.button<{ isCollapsed?: boolean }>`
  position: absolute;
  top: 8px;
  bottom: 8px;
  left: 8px;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  padding: 0;

  .svg-icon {
    color: var(--text-color-40);

    transform: rotate(${props => props.isCollapsed ? "-90deg" : "0deg"});
    transition: transform 0.1s;
  }
`

const FilePath = styled(EllipsisContainer)`
  font-size: 12px;
  line-height: 16px;

  color: var(--secondary-text-color);
`

const Clickable = css`
  cursor: pointer;
`

const WithCloseButton = css`
  margin-right: 24px;
`

export const DiffFileHeaderStyles = {
  Container,
  CloseButton,
  Collapse,
  FilePath,
  Clickable,
  WithCloseButton
}